import { render, staticRenderFns } from "./emailNotification-dialog.vue?vue&type=template&id=68d2874f&"
import script from "./emailNotification-dialog.vue?vue&type=script&lang=js&"
export * from "./emailNotification-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports